import { useEffect, useRef, useState } from "react";
import API from "../api/api";
import AdminLayout from "../layouts/AdminLayout";
import TemplateEditor from "../components/email/TemplateEditor";
import VariablePanel from "../components/email/VariablePanel";


export default function Email(){

const [activeTab,setActiveTab] = useState("templates");


const [templates,setTemplates]=useState([]);
const [bookings,setBookings]=useState([]);
const [bookingPage,setBookingPage] = useState(1);

const [bookingTotal,setBookingTotal] = useState(0);

const BOOKINGS_PER_PAGE = 50;
const [guides,setGuides]=useState([]);

const [selectedGuides,setSelectedGuides]=useState([]);

const [reminders,setReminders]=useState([]);

const [reminderForm,setReminderForm]=useState({
    hours_before:"",
    template_id:""
});

const [tourFilter,setTourFilter]=useState("");
const [dateFilter,setDateFilter]=useState("");
const [statusFilter,setStatusFilter]=useState("");
const searchInputRef = useRef(null);

const [tours,setTours]=useState([]);


const [selectedTemplate,setSelectedTemplate]=useState("");

const [selectedBookings,setSelectedBookings]=useState([]);

const [sessions,setSessions]=useState([]);

const [selected,setSelected]=useState(null);



const [form,setForm]=useState({

name:"",
subject:"",
body:"",
category:"general"

});



useEffect(()=>{

loadTemplates();

},[]);


/* ================= FORMAT DATE ================= */

const formatDateTime = (dateString) => {

    if (!dateString) return "No date";

    const date = new Date(dateString);

    const weekday = date.toLocaleDateString("en-GB", {
        weekday: "long"
    });

    const day = String(date.getDate()).padStart(2, "0");

    const month = date.toLocaleDateString("en-GB", {
        month: "long"
    });

    const year = date.getFullYear();

    const time = date.toLocaleTimeString("en-GB", {
        hour: "2-digit",
        minute: "2-digit",
        hour12: false
    });


    return `${weekday}, ${day} ${month} ${year} • ${time}`;

};

/* ================= LOADERS ================= */


const loadTemplates = async()=>{

try{

const res = await API.get("/email/templates");

setTemplates(res.data);

}catch(err){

console.log(err);

}

};



const loadBookings = async (page = 1) => {

    try {

        const params = {
            page,
            limit: BOOKINGS_PER_PAGE
        };

        if (tourFilter) {
            params.tour_id = tourFilter;
        }

        if (dateFilter) {
            params.date = dateFilter;
        }

        if (statusFilter) {
            params.status = statusFilter;
        }

        const searchValue =
    searchInputRef.current?.value.trim() || "";

if (searchValue) {
    params.search = searchValue;
}

        const res = await API.get(
            "/admin/email/bookings",
            {
                params
            }
        );

        
const data = res.data;


        /*
        =============================================
        SUPPORT BOTH RESPONSE FORMATS
        =============================================
        */

        if (Array.isArray(data)) {

            // Backend is still returning the old array format
            setBookings(
                data.slice(
                    0,
                    BOOKINGS_PER_PAGE
                )
            );

            setBookingTotal(
                data.length
            );

        } else {

            // Paginated backend response
            setBookings(
                Array.isArray(data.rows)
                    ? data.rows.slice(
                        0,
                        BOOKINGS_PER_PAGE
                    )
                    : []
            );

            setBookingTotal(
                Number(data.total) || 0
            );

        }

        setBookingPage(page);

    } catch (err) {

        console.log(
            "BOOKING LOAD ERROR:",
            err.response?.data || err
        );

        setBookings([]);
        setBookingTotal(0);

    }

};


const loadGuides = async()=>{

    try{

        const res = await API.get(
            "/admin/guide-email/guides"
        );

        setGuides(res.data);

    }catch(err){

        console.log(
            "Guide loading error",
            err
        );

    }

};



const loadReminders = async()=>{

    try{

        const res =
        await API.get(
            "/admin/guide-reminders"
        );

        setReminders(res.data);


    }catch(err){

        console.log(
            "Reminder load error",
            err
        );

    }

};



const loadTours = async()=>{

const res = await API.get("/tours");

setTours(res.data);

};



/* ================= TEMPLATE CRUD ================= */


const saveTemplate = async()=>{


try{


if(selected){


await API.put(
`/email/templates/${selected}`,
form
);


}else{


await API.post(
"/email/templates",
form
);


}



loadTemplates();

clear();


}catch(err){

console.log(err);

}


};




const editTemplate=(t)=>{


setSelected(t.id);


setForm({

name:t.name,
subject:t.subject,
body:t.body,
category:t.category

});


};





const deleteTemplate=async(id)=>{


if(!window.confirm("Delete template?"))
return;



await API.delete(
`/email/templates/${id}`
);


loadTemplates();


};




const clear=()=>{


setSelected(null);


setForm({

name:"",
subject:"",
body:"",
category:"general"

});


};





/* ================= SEND EMAILS ================= */

const sendSessionEmail = async(session_id)=>{


if(!selectedTemplate){

alert("Select email template first");

return;

}



try{


await API.post(

"/admin/email/send-session",

{

template_id:selectedTemplate,

session_id

}

);



alert("Session emails sent");


}catch(err){


console.log(err);


alert("Sending failed");


}



};


const sendEmails=async()=>{


try{


await API.post(

"/admin/email/send-booking",

{

template_id:selectedTemplate,

booking_ids:selectedBookings

}

);



alert("Emails sent");


}catch(err){

console.log(err);

alert("Sending failed");

}


};

const sendGuideEmails = async()=>{


    if(
        !selectedTemplate ||
        selectedGuides.length===0
    ){

        alert(
            "Select template and guides"
        );

        return;

    }


    await API.post(
        "/admin/guide-email/send",
        {
            template_id:selectedTemplate,
            guide_ids:selectedGuides
        }
    );


    alert(
        "Guide emails sent"
    );


};





return (

<AdminLayout>

<div style={page}>


{/* HEADER */}

<div style={header}>

<div>

<h1 style={title}>
Email Management
</h1>

<p style={subtitle}>
Create templates, send guest emails, manage guide communication and reminders.
</p>

</div>


</div>





{/* TABS */}

<div style={tabs}>


<button

style={
activeTab==="templates"
?
activeTabBtn
:
tabBtn
}

onClick={()=>setActiveTab("templates")}

>

📝 Templates

</button>




<button

style={
activeTab==="guests"
?
activeTabBtn
:
tabBtn
}


onClick={() => {

    setActiveTab("guests");

    setBookingPage(1);

    loadTours();

    loadBookings(1);

}}

>

👥 Guest Emails

</button>





<button

style={
activeTab==="guides"
?
activeTabBtn
:
tabBtn
}


onClick={()=>{

setActiveTab("guides");

loadGuides();
loadReminders();

}}

>

🧑‍🏫 Guide Emails

</button>


</div>


{/* ================= TEMPLATE TAB ================= */}



{
activeTab==="templates" && (

<div style={layout}>


<div style={card}>


<h3>
Templates
</h3>


<button
style={newBtn}
onClick={clear}
>

+ New Template
</button>



{
templates.map(t=>(

<div
key={t.id}
style={templateCard}
>


<strong>
{t.name}
</strong>


<p>
{t.category}
</p>



<button

style={editBtn}

onClick={()=>editTemplate(t)}

>
Edit
</button>



<button

style={deleteBtn}

onClick={()=>deleteTemplate(t.id)}

>
Delete
</button>


</div>


))

}


</div>






<div style={card}>


<h3>

{
selected
?"Edit Template"
:"Create Template"

}

</h3>




<input

style={input}

placeholder="Template name"

value={form.name}

onChange={e=>

setForm({

...form,

name:e.target.value

})

}

/>




<input

style={input}

placeholder="Subject"

value={form.subject}

onChange={e=>

setForm({

...form,

subject:e.target.value

})

}

/>




<select

style={input}

value={form.category}

onChange={e=>

setForm({

...form,

category:e.target.value

})

}

>


<option value="general">
General
</option>

<option value="booking">
Booking
</option>

<option value="guide">
Guide
</option>


</select>




<TemplateEditor
    value={form.body}
    onChange={(value)=>
        setForm({
            ...form,
            body:value
        })
    }
/>




<VariablePanel />





<button

style={saveBtn}

onClick={saveTemplate}

>

Save Template

</button>



</div>



</div>

)

}







{/* ================= GUEST EMAIL TAB ================= */}


{
activeTab==="guests" && (

<div style={guestLayout}>


{/* TOP CARD */}

<div style={card}>


<div style={cardHeader}>

<div>

<h2>
👥 Guest Emails
</h2>

<p style={smallText}>
Send emails to guests from bookings or entire tour sessions.
</p>

</div>


</div>





{/*
    =================================================
    SEND EMAIL TO ENTIRE TOUR SESSION

    Temporarily hidden from the UI.
    Functionality is intentionally kept for later.
    =================================================
*/}

<div style={{ display: "none" }}>

    <h3>
        📅 Send To Entire Tour Session
    </h3>

    <select
        style={input}
        onChange={e => {

            if (e.target.value) {

                sendSessionEmail(
                    e.target.value
                );

            }

        }}
    >

        <option value="">
            Select Session
        </option>

        {
            sessions.map(s => (

                <option
                    key={s.session_id}
                    value={s.session_id}
                >

                    {s.tour_name}

                    •

                    {formatDateTime(
                        s.start_datetime
                    )}

                    •

                    {s.guest_count} guests

                </option>

            ))
        }

    </select>

</div>



</div>








{/* FILTER CARD */}


<div style={card}>


<h3>
🔎 Search & Filters
</h3>



<div style={filters}>








<select

style={input}

value={tourFilter}

onChange={e=>
setTourFilter(e.target.value)
}

>


<option value="">
All Tours
</option>


{
tours.map(t=>(

<option

key={t.id}

value={t.id}

>

{t.title}

</option>


))

}


</select>






<input

type="date"

style={input}

value={dateFilter}

onChange={e=>
setDateFilter(e.target.value)
}

/>







<select

style={input}

value={statusFilter}

onChange={e=>
setStatusFilter(e.target.value)
}

>


<option value="">
All Status
</option>


<option value="confirmed">
Confirmed
</option>


<option value="cancelled">
Cancelled
</option>


</select>



</div>








</div>









{/* EMAIL ACTIONS */}



<div style={card}>

    <h3>
        ✉️ Email Setup
    </h3>


    <select
        style={input}
        value={selectedTemplate}
        onChange={e =>
            setSelectedTemplate(
                e.target.value
            )
        }
    >

        <option value="">
            Select Template
        </option>

        {
            templates.map(t => (

                <option
                    key={t.id}
                    value={t.id}
                >
                    {t.name}
                </option>

            ))
        }

    </select>


    <input
    ref={searchInputRef}
    placeholder="Search guest by name or email..."
    style={input}
/>


    <button
        style={filterBtn}
        onClick={() => {

            setBookingPage(1);

            loadBookings(1);

        }}
    >
        🔎 Search Guests
    </button>


    <div style={selectedInfo}>

        Selected Guests:

        <strong>
            {" "}
            {selectedBookings.length}
        </strong>

    </div>

</div>



{/* BOOKINGS */}



<div style={card}>


<h2>
Bookings
</h2>




<div style={bookingGrid}>


{
bookings.length===0

?


<div style={empty}>
No bookings found
</div>



:


bookings.map(b=>(



<div

key={b.booking_id}

style={bookingCard}

>


<div style={bookingTop}>


<input

type="checkbox"


checked={
selectedBookings.includes(
b.booking_id
)
}



onChange={e=>{


if(e.target.checked){


setSelectedBookings([

...selectedBookings,

b.booking_id

]);


}

else{


setSelectedBookings(

selectedBookings.filter(

id=>id!==b.booking_id

)

);


}


}}


/>



    


<span style={statusBadge}>
Booking #{b.booking_id}
</span>



</div>





<h3>

{b.first_name}

{" "}

{b.last_name}

</h3>



<div style={emailText} title={b.email || ""}>
📧 {b.email}
</div>


<div style={smallText}>
📞 {b.phone || "No phone"}
</div>


<div style={smallText}>
🎫 {b.tour_name}
</div>


<div style={smallText}>
📅 {formatDateTime(
b.start_datetime
)}
</div>



</div>



))




}

<div
    style={{
        gridColumn: "1 / -1",
        display: "flex",
        justifyContent: "center",
        alignItems: "center",
        gap: 15,
        marginTop: 20
    }}
>

    <button
        style={filterBtn}
        disabled={bookingPage <= 1}
        onClick={() => {

            const nextPage =
                bookingPage - 1;

            setBookingPage(nextPage);

            loadBookings(nextPage);

        }}
    >
        ← Previous
    </button>


    <span style={smallText}>
        Page {bookingPage} of{" "}
        {Math.max(
            1,
            Math.ceil(
                bookingTotal /
                BOOKINGS_PER_PAGE
            )
        )}
    </span>


    <button
        style={filterBtn}
        disabled={
            bookingPage >=
            Math.ceil(
                bookingTotal /
                BOOKINGS_PER_PAGE
            )
        }
        onClick={() => {

            const nextPage =
                bookingPage + 1;

            setBookingPage(nextPage);

            loadBookings(nextPage);

        }}
    >
        Next →
    </button>

</div>

</div>








<button

style={sendBtn}

onClick={sendEmails}

>

📨 Send Email

</button>



</div>





</div>

)

}

{/* ================= GUIDE EMAIL TAB ================= */}


{
activeTab==="guides" && (

<>

<div style={card}>


<h2>
Guide Emails
</h2>



<h3>
Select Template
</h3>


<select
value={selectedTemplate}
onChange={
e=>setSelectedTemplate(e.target.value)
}
style={input}
>


<option value="">
Select guide template
</option>


{
templates
.filter(
t=>t.category==="guide"
)
.map(t=>(

<option
key={t.id}
value={t.id}
>

{t.name}

</option>

))
}


</select>



<h3>
Select Guides
</h3>


{
guides.map(g=>(


<div
key={g.id}
style={guideRecipient}
>


<input

type="checkbox"

checked={
selectedGuides.includes(g.id)
}


onChange={e=>{


if(e.target.checked){

setSelectedGuides([
...selectedGuides,
g.id
]);

}
else{

setSelectedGuides(
selectedGuides.filter(
id=>id!==g.id
)
);

}


}}

/>


{" "}

{g.first_name}
{" "}
{g.last_name}

<span style={emailText} title={g.email || ""}>({g.email})</span>


</div>


))
}



<button

style={saveBtn}

onClick={sendGuideEmails}

>

Send Guide Email

</button>


</div>






<div style={card}>


<h2>
Automatic Guide Reminders
</h2>


<p>
Send automatic reminders before tours start.
</p>



<select

style={input}

value={
reminderForm.template_id
}

onChange={
e=>
setReminderForm({

...reminderForm,

template_id:e.target.value

})
}

>


<option value="">
Select reminder template
</option>


{
templates
.filter(
t=>t.category==="guide"
)
.map(t=>(

<option
key={t.id}
value={t.id}
>

{t.name}

</option>

))
}


</select>



<input

style={input}

type="number"

placeholder="Hours before tour"

value={
reminderForm.hours_before
}

onChange={
e=>
setReminderForm({

...reminderForm,

hours_before:e.target.value

})
}

/>



<button

style={saveBtn}

onClick={async()=>{


await API.post(

"/admin/guide-reminders",

reminderForm

);


loadReminders();


}}
 disabled={
        !reminderForm.template_id ||
        reminderForm.hours_before === ""
    }
>

Save Reminder

</button>



<h3>
Active reminders
</h3>



{
reminders.map(r=>(

<div
key={r.id}
style={templateCard}
>

{r.hours_before} hours before tour


<button

onClick={async()=>{


await API.delete(

`/admin/guide-reminders/${r.id}`

);


loadReminders();


}}

>

Delete

</button>


</div>

))
}



</div>


</>

)

}



</div>

</AdminLayout>


);

}

/* ================= STYLES ================= */

const page = {
    padding: window.innerWidth < 900 ? 16 : 24,
    background: "#f5f6f8",
    minHeight: "100vh",
    boxSizing: "border-box",
    color: "#172033"
};

const tabs = {
    display: "flex",
    flexDirection: window.innerWidth < 900 ? "column" : "row",
    flexWrap: "wrap",
    gap: 6,
    padding: 5,
    marginBottom: 20,
    width: "fit-content",
    maxWidth: "100%",
    background: "#e9edf1",
    borderRadius: 12
};

const tabBtn = {
    padding: "10px 16px",
    border: "none",
    borderRadius: 9,
    background: "transparent",
    color: "#526078",
    cursor: "pointer",
    fontWeight: 600,
    width: window.innerWidth < 900 ? "100%" : "auto",
    textAlign: "center"
};

const activeTabBtn = {
    ...tabBtn,
    background: "#ffffff",
    color: "#c75028",
    boxShadow: "0 1px 4px rgba(20,30,50,0.10)"
};

const filters = {
    display: "grid",
    gridTemplateColumns: window.innerWidth < 900 ? "1fr" : "repeat(3, minmax(0, 1fr))",
    gap: 12,
    marginBottom: 16
};

const layout = {
    display: "grid",
    gridTemplateColumns: window.innerWidth < 900 ? "1fr" : "minmax(280px, 0.85fr) minmax(0, 1.5fr)",
    gap: 20,
    alignItems: "start"
};

const card = {
    background: "#ffffff",
    padding: window.innerWidth < 900 ? 16 : 20,
    borderRadius: 14,
    border: "1px solid #e2e7ed",
    boxShadow: "0 2px 8px rgba(20,30,50,0.04)",
    minWidth: 0,
    boxSizing: "border-box"
};

const templateCard = {
    padding: "13px 0",
    borderBottom: "1px solid #edf0f3",
    overflowWrap: "anywhere"
};

const input = {
    width: "100%",
    boxSizing: "border-box",
    padding: "11px 12px",
    marginBottom: 10,
    borderRadius: 8,
    border: "1px solid #d9e0e8",
    background: "#ffffff",
    color: "#263247",
    fontSize: 14,
    minWidth: 0
};

const saveBtn = {
    background: "#c75028",
    color: "#ffffff",
    padding: "10px 18px",
    border: 0,
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600
};

const newBtn = {
    background: "#c75028",
    color: "#ffffff",
    border: 0,
    padding: "9px 14px",
    borderRadius: 8,
    marginBottom: 15,
    cursor: "pointer",
    fontWeight: 600
};

const editBtn = {
    marginRight: 8,
    padding: "7px 11px",
    border: "1px solid #d9e0e8",
    borderRadius: 7,
    background: "#ffffff",
    color: "#344054",
    cursor: "pointer"
};

const deleteBtn = {
    padding: "7px 11px",
    border: "1px solid #f2d4d0",
    borderRadius: 7,
    background: "#fff5f3",
    color: "#b54735",
    cursor: "pointer"
};

const header = {
    display: "flex",
    flexDirection: window.innerWidth < 900 ? "column" : "row",
    alignItems: window.innerWidth < 900 ? "flex-start" : "center",
    gap: 12,
    marginBottom: 22
};

const title = {
    fontSize: window.innerWidth < 900 ? 26 : 30,
    fontWeight: 750,
    color: "#172033",
    margin: 0
};

const subtitle = {
    color: "#718096",
    marginTop: 5,
    fontSize: 14,
    lineHeight: 1.45
};

const cardHeader = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 12,
    marginBottom: 15
};

const empty = {
    padding: 22,
    textAlign: "center",
    background: "#f7f8fa",
    border: "1px dashed #d9e0e8",
    borderRadius: 10,
    color: "#718096"
};

const smallText = {
    fontSize: 13,
    color: "#718096",
    lineHeight: 1.5,
    overflowWrap: "anywhere"
};

const emailText = {
    fontSize: 13,
    color: "#718096",
    lineHeight: 1.5,
    display: "block",
    maxWidth: "100%",
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap"
};

const guideRecipient = {
    display: "flex",
    alignItems: "center",
    gap: 10,
    padding: "10px 0",
    borderBottom: "1px solid #edf0f3",
    minWidth: 0,
    overflow: "hidden"
};

const guestLayout = {
    display: "flex",
    flexDirection: "column",
    gap: 18,
    minWidth: 0
};

const bookingGrid = {
    display: "grid",
    gridTemplateColumns: window.innerWidth < 900 ? "1fr" : "repeat(auto-fill, minmax(260px, 1fr))",
    gap: 12,
    minWidth: 0
};

const bookingCard = {
    background: "#ffffff",
    padding: 16,
    borderRadius: 12,
    border: "1px solid #e2e7ed",
    minWidth: 0,
    overflow: "hidden",
    boxSizing: "border-box"
};

const bookingTop = {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    gap: 10,
    marginBottom: 10
};

const statusBadge = {
    background: "#fff1e8",
    color: "#b84b25",
    padding: "5px 10px",
    borderRadius: 20,
    fontSize: 12,
    fontWeight: 600
};

const selectedInfo = {
    background: "#f7f8fa",
    border: "1px solid #e2e7ed",
    padding: 12,
    borderRadius: 10,
    marginTop: 10,
    color: "#526078"
};

const filterBtn = {
    background: "#ffffff",
    color: "#344054",
    border: "1px solid #d9e0e8",
    padding: "10px 16px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 600
};

const sendBtn = {
    background: "#c75028",
    color: "#ffffff",
    border: "none",
    padding: "12px 22px",
    borderRadius: 8,
    cursor: "pointer",
    fontWeight: 700,
    marginTop: 18,
    width: window.innerWidth < 900 ? "100%" : "auto"
};
